import { useEffect, useState } from 'react'
import { apiService } from '@/service/api'

/**
 * Whether a time-series document is fed by a connector, from the live readings endpoint's own
 * `live` flag. Asks once when `enabled` is true (keep it true once set, so closing and reopening
 * a menu does not ask again). A failure, or a document the endpoint rejects (not a time-series
 * upload), reads as "not live".
 */
export function useIsLiveDocument(documentId: string | undefined, enabled: boolean): boolean {
  const [liveFor, setLiveFor] = useState<string | null>(null)

  useEffect(() => {
    if (!enabled || !documentId) return
    let cancelled = false
    apiService
      .getLiveReadings(documentId)
      .then((r) => {
        if (!cancelled && r.live) setLiveFor(documentId)
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
  }, [enabled, documentId])

  return liveFor !== null && liveFor === documentId
}
